import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryTicketUserRecords = async (params: object) => {
  return await POST({
    url: Api.queryTicketUserRecords,
    data: params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Content-Type': 'application/json'
    },
    dataType: 'json'
  })
}
export const cancelComplaint = async (params: object) => {
  return await POST({
    url: Api.cancelComplaint,
    data: params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Content-Type': 'application/json'
    },
    dataType: 'json'
  })
}
export const urgeTicket = async (params: object) => {
  return await POST({
    url: Api.urgeTicket,
    data: params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Content-Type': 'application/json'
    },
    dataType: 'json'
  })
}
